import homeUrl from '/public/icons/advantage/home.svg'
import yogaUrl from '/public/icons/advantage/yoga.svg'
import playUrl from '/public/icons/advantage/play.svg'
import foodUrl from '/public/icons/advantage/food.svg'
import trainingUrl from '/public/icons/advantage/training.svg'
import muscleUrl from '/public/icons/advantage/muscle.svg'

export const ADVANTAGES = [
  {
    iconImagePath: homeUrl,
    title: 'Sem sair de casa',
    subtitle: 'Resultados treinando de onde e quando quiser.'
  },
  {
    iconImagePath: yogaUrl,
    title: 'Treinos para todos',
    subtitle: 'Níveis iniciantes, intermediários e avançados'
  },
  {
    iconImagePath: playUrl,
    title: '+ de 400 treinos ao vivo por mês',
    subtitle: 'E uma vasta biblioteca de aulas gravadas'
  },
  {
    iconImagePath: foodUrl,
    title: 'Guias alimentares',
    subtitle: 'Cardápios diferentes para cada objetivo.'
  },
  {
    iconImagePath: trainingUrl,
    title: 'Treinos interativos',
    subtitle: 'Correções e dúvidas ao vivo com o professor.'
  },
  {
    iconImagePath: muscleUrl,
    title: '+ de 10 modalidades ao vivo',
    subtitle: 'Treinos de diversas modalidades para fazer.'
  }
]
